module.exports = __webpack_public_path__ + "img/img_24.fc369d51.jpg";